module.exports = __webpack_public_path__ + "img/1c_Dashboard.d9ef83bb.png";